export default "__VITE_ASSET__BHGWs0Z5__"